import { Box, Flex, Text, Circle } from '@chakra-ui/react';
import { themeVariables } from '../theme';

type StepGuideProps = {
  step: string;
  hasBorder?: boolean;
  circlePadding?: string;
};

const StepGuide = ({
  step,
  hasBorder = false,
  circlePadding = '0.6rem',
}: StepGuideProps) => {
  const currentStep = parseInt(step, 10);
  return (
    <Flex
      justify="space-between"
      position="relative"
      alignItems="center"
      width="100%"
      padding={hasBorder ? '1rem' : ''}
      borderRadius="0.75rem"
      border={hasBorder ? `1px solid ${themeVariables.cards.stroke}` : ''}
      sx={{
        fontSize: { lg: '0.875rem', sm: '10px' },
      }}
      fontWeight={500}
    >
      <Circle
        padding={circlePadding}
        bg={currentStep >= 1 ? themeVariables.purple.metera : '#E2E8F0'}
        color={currentStep >= 1 ? 'white' : '#262626'}
        zIndex={1}
      >
        1. Zap-in
      </Circle>

      <Circle
        padding={circlePadding}
        bg={currentStep >= 2 ? themeVariables.purple.metera : '#E2E8F0'}
        color={currentStep >= 2 ? 'white' : '#262626'}
        zIndex={1}
      >
        2. Track & Receive
      </Circle>

      <Circle
        padding={circlePadding}
        bg={currentStep >= 3 ? themeVariables.purple.metera : '#E2E8F0'}
        color={currentStep >= 3 ? 'white' : '#262626'}
        fontWeight={500}
        zIndex={1}
      >
        3. Mint MTKs
      </Circle>

      {/* The connector box */}
      <Box
        position="absolute"
        width={hasBorder ? '80%' : '100%'}
        top="50%"
        h="2px"
        bg={currentStep >= 1 ? themeVariables.purple.metera : '#E2E8F0'}
        zIndex={0}
      />
    </Flex>
  );
};

export default StepGuide;
